import { render, staticRenderFns } from "./overflowMessage.vue?vue&type=template&id=148f8cf0&scoped=true&"
import script from "./overflowMessage.vue?vue&type=script&lang=js&"
export * from "./overflowMessage.vue?vue&type=script&lang=js&"
import style0 from "./overflowMessage.vue?vue&type=style&index=0&id=148f8cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f8cf0",
  null
  
)

export default component.exports